import { FormGroup } from '@angular/forms';

export interface UserState {
  timestamp: number;
  userDetails: any;
  error: string;
  pwdResetCodeSent: boolean;
  newAccountFormGroup: any;
  passwordResetSuccess: boolean;
  onBoardingDetails: any;
  isPackageExpired: boolean;
  sendPwdResetCodeSuccess: boolean;
}

export const initialUserState: UserState = {
  userDetails: null,
  error: null,
  pwdResetCodeSent: false,
  newAccountFormGroup: null,
  passwordResetSuccess: false,
  onBoardingDetails: null,
  isPackageExpired: false,
  sendPwdResetCodeSuccess: false,
  timestamp
    : Date.now(),
};
